import { axiosInstance, requestConfig } from 'network/apis';

import { URL_GAME } from 'utils/constants';

export const callGameHistoryList = async (data) => {
    return await axiosInstance(requestConfig('get', URL_GAME, '/game-round', data));
};
